import { Alert, Divider, Flex, Form, Space } from 'antd';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { userSelectors } from 'src/store';
import { useTheme } from 'src/styles/theme';

import classes from '../../screens/login/style/Login.module.css';
import AppFormItem from '../appFormItem';
import AppInput from '../appInput';
import AppPrimaryButton from '../appPrimaryButton/AppPrimaryButton';

const ALERT_WRAPPER = {
  width: '100%',
  padding: 5,
  marginBottom: 20
};
interface IProps {
  onSubmit: (values: { code: string }) => void;
  isLoading: boolean;
  errorMessage?: string | null;
}

const SmsForm = (props: IProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [form] = Form.useForm();
  const hospital = useSelector(userSelectors.selectUserHospital);

  const smsInputRef = React.useRef<HTMLInputElement>();
  const { onSubmit, isLoading, errorMessage } = props;

  useEffect(() => {
    setTimeout(() => smsInputRef.current?.focus(), 300);
  }, [smsInputRef]);

  return (
    <Flex
      align="flex-start"
      justify="center"
      className={classes.formInnerContainer}
    >
      <Form
        form={form}
        name="basic"
        initialValues={{ remember: true }}
        onFinish={onSubmit}
        className={`${classes.form}`}
      >
        <Space direction="vertical" size="small" className={classes.formTitle}>
          <h1 className={`${theme.fonts.classNames.subPageTitle} `}>
            {t('sms.title')}
          </h1>
          <h1 className={`${theme.fonts.classNames.pageTitle} `}>
            {t('sms.subTitle')}
          </h1>
        </Space>
        <Flex
          justify="center"
          className={classes.mobileLogo}
          vertical
          align="center"
        >
          <img
            className={`${classes.logo} `}
            src={hospital?.logo || '/assets/space_saver.png'}
            alt={t('accessibility.ministryOfHealthLogo')}
            title={t('accessibility.ministryOfHealthLogo')}
          />
          {/* <p className={`${theme.fonts.classNames.cardTitle}`}>
            {`${t('login.medicalCenter')} ${hospital?.name}`}{' '}
          </p> */}
        </Flex>

        <AppFormItem
          labelCol={{ span: 24 }}
          aria-label={t('sms.code')}
          aria-required="true"
          label={t('sms.code')}
          name="code"
          validateTrigger={'onBlur'}
          rules={[{ required: true, message: t('erros.requiredField') }]}
        >
          <AppInput
            label={t('sms.code')}
            inputRef={smsInputRef}
            autoFocus
            autoComplete="one-time-code"
            inputMode="numeric"
          />
        </AppFormItem>
        {errorMessage && (
          <div style={ALERT_WRAPPER}>
            <Alert message={errorMessage} type="error" />
          </div>
        )}
        <AppPrimaryButton
          block
          htmlType="submit"
          loading={isLoading}
          disabled={isLoading}
        >
          {t('login.submit')}
        </AppPrimaryButton>
        <Divider />
        <Flex justify="center" align="center">
          <div className={`${theme.fonts.classNames.comment}`}>
            {t('login.addition')}
          </div>
        </Flex>
      </Form>
    </Flex>
  );
};

export default SmsForm;
